import React from "react";
import styles from "./style.module.css";

import "rc-slider/assets/index.css";

import Slider, { Range } from "rc-slider";

import { LineInput } from "components/Inputs/LineInput";

export default class InputSliderMini extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      timeout: true
    };
  }

  render() {
    const {
      min,
      max,
      label,
      onChange,
      value,
      step,
      marks,
      isDollar,
      isLocked,
      isWideLabel,
      className,
      style,
      endLabel
    } = this.props;

    const { timeout } = this.state;

    return (
      <div>
        <div className={(className ? className : "") + " " + styles.sliderHolder} style={style ? { ...style } : {}}>
          <div
            className={styles.label}
            style={label === undefined ? { width: "0px" } : isWideLabel ? { width: "200px" } : {}}
          >
            {label}
          </div>
          <div className={styles.inputSliderMini}>
            <Slider
              type="range"
              min={min}
              max={max}
              onChange={
                isLocked || timeout === false
                  ? () => {}
                  : (value) => {
                      this.setState({ timeout: false });

                      onChange(Number(value));

                      setTimeout(() => this.setState({ timeout: true }), 50);
                    }
              }
              value={Number(value)}
              step={step ? step : 1}
              marks={marks}
              trackStyle={{ backgroundColor: "var(--aible-color)" }}
              handleStyle={{
                backgroundColor: "var(--aible-color)",
                borderColor: "white",
                boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)"
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
